import React from "react";
import { Card, Flex, Text, Button, Link } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import { AccountActivationCardHeader } from "apps/portal/Portal/common/AccountActivation/AccountActivationCardHeader";
import { broadcastLogout } from "common/utils/coordinatedLogout";
import {
  pageContainer,
  informationStyle,
  contentWrapper,
  headerLogo,
  buttonStyle,
  informationHeaderStyle,
} from "./styles_vanilla.css";
import { useAppContext } from "../AppContext";

export const NotFoundPageV2 = ({ arenaName }: { arenaName: string }) => {
  const { currentArenaContent } = useAppContext();
  const singleManager = !!currentArenaContent;

  const handleLogout = () => {
    broadcastLogout();
    window.location.assign(
      singleManager && currentArenaContent
        ? `/logout?arena=${currentArenaContent.arenaDomain}`
        : "/logout",
    );
  };
  return (
    <div className={pageContainer}>
      <Flex flexDirection="column" gap={Sizes.XL} alignItems="center">
        <img src={currentArenaContent?.headerLogoUrl} alt="ArenaLogo" className={headerLogo} />
        <Card className={contentWrapper} padding="xl">
          <AccountActivationCardHeader helpMessage="This page may have been moved, deleted, or you may not have permission to access it." />
          <Text variant="h1" align="center" className={informationHeaderStyle}>
            There&apos;s nothing here
          </Text>
          <Text variant="regular-md" className={informationStyle}>
            This page may have been moved, deleted, or you may not have permission to access it.
            <br />
            <br />
            If you arrived here from an email from Juniper Square, the link may be expired or no
            longer valid.
            <br />
            <br />
            If this link was forwarded to you, you should reach out to the sender and ask them
            to grant you access to this investment with {arenaName}.
          </Text>
          <Link variant="primary" displayAsButton to="/lp/home" className={buttonStyle}>
            Continue to portal
          </Link>
          <Button variant="neutral" onClick={() => handleLogout()} className={buttonStyle}>
            Log out
          </Button>
        </Card>
      </Flex>
    </div>
  );
};
